import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <span class="created-by" style="font-size:12px">
    © 優果科技股份有限公司版權所有，轉載、編輯必究
    Copyright © 2024 YOUGUO Technology Co., Ltd. All Right Reserved
    </span>
  `,
})
export class FooterComponent {
}
